
import React from 'react';
import styles from './_scoring-admin-page.module.scss';
import ScoringEvaluator from '../OrderEditor/ScoringEvaluator/ScoringEvaluator';



export interface ScoringAdminPageProps {

}

export default function ScoringAdminPage (props:  ScoringAdminPageProps) {  
  return (
    <div className={styles.scoringAdminPageContainer}>
      <ScoringEvaluator />
    </div>
  );
}
